module.exports = __webpack_public_path__ + "static/media/logo.152a61f1.png";